'use client';

import * as React from 'react';
import { cn } from '@/core/lib/utils';

export interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name?: string;
}

const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  ({ className, label, id, name, ...props }, ref) => {
    const generatedId = React.useId();
    const radioId = id || generatedId;

    return (
      <label
        className='relative inline-flex items-center gap-2 cursor-pointer select-none'
        htmlFor={radioId}
        data-pte-name='radio'
      >
        <input
          type='radio'
          id={radioId}
          ref={ref}
          className='peer sr-only'
          name={name || radioId}
          data-pte-name='radio-input'
          {...props}
        />
        <span
          className={cn(
            'relative w-[20px] h-[20px] rounded-full border-2 border-black bg-container-primary',
            "before:content-[''] before:absolute before:inset-[4px] before:rounded-full before:bg-primary-default",
            'peer-checked:border-primary-default before:scale-0 peer-checked:before:scale-100 before:transition-transform before:duration-200',
            className
          )}
          data-pte-name='radio-indicator'
        />
        {label && (
          <span
            className='text-[14px] leading-[1.2]'
            data-pte-name='radio-label'
          >
            {label}
          </span>
        )}
      </label>
    );
  }
);

Radio.displayName = 'Radio';

export { Radio };
